import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetUserService = () => {
  return HTTP_CLIENT.get(Endpoint.user.get);
};

const UpdateProfileService = (payload: UpdateProfileType) => {
  return HTTP_CLIENT.post(Endpoint.user.update, {
    name: payload.fullname,
    role: payload.role,
  });
};

const ChangePasswordService = (payload: UpdatePasswordType) => {
  return HTTP_CLIENT.post(Endpoint.user.changePassword, {
    password: payload.password,
    oldPassword: payload.oldPassword,
  });
};

export { GetUserService, UpdateProfileService, ChangePasswordService };
